<template>
  <div style="min-width: 60%">
    <h1 class="grey--text text--darken-2">Рекламные инструменты</h1>

    <div class="mt-3 mb-3">
      <v-btn small :color="selectedItems.length ? 'red' : 'secondary'" :disabled="!selectedItems.length" @click="deleteAction(selectedItems)">
        <v-icon left dark>mdi-delete-circle-outline</v-icon> Удалить
      </v-btn>
      <v-btn small color="blue" dark @click="createAction" class="ml-3">
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Создать
      </v-btn>
      <v-btn small color="yellow" @click="refreshAction" class="ml-3">
        <v-icon left dark>mdi-refresh</v-icon> Обновить
      </v-btn>
    </div>

    <v-data-table
      v-model="selectedItems"
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="spotID"
      hide-default-footer
      disable-filtering
      disable-pagination
      disable-sort
      no-data-text="Рекламные инструменты отсутствуют"
      show-select
      dense
      class="elevation-1">
      <template #item.spotType="{ item }">
        <v-chip :color="colorByType(item.spotType)" small dark>{{ item.spotType }}</v-chip>
      </template>
      <template #item.spotName="{ item }">
        <span @click="editAction(item)" class="editable" style="cursor: pointer">{{ item.spotName }}</span>
      </template>
      <template #item.spotUrl="{ item }">
        <a :href="item.spotUrl" target="_blank">{{ item.spotUrl.length > 80 ? item.spotUrl.substr(0, 80) + '...' : item.spotUrl }}</a>
      </template>
      <template #item.spotIsOff="{ item }">
        <v-icon large :color="item.spotIsOff ? 'red' : 'green'" @click="toggleAction(item)">{{ item.spotIsOff == '1' ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch-outline' }}</v-icon>
      </template>
    </v-data-table>

    <SpotsDialog ref="spotsDialog" @updated="load()"/>
  </div>
</template>

<script>
import api from '../api'
import { combinedObject } from '@/common.js'

import SpotsDialog from '../components/SpotsDialog.vue'

export default {
  components: { SpotsDialog },
  data: () => ({
    loading: false,
    selectedItems: [],
    headers: [
      { value: 'spotType', text: 'Тип', align: 'center' },
      { value: 'spotName', text: 'Наименование' },
      { value: 'spotUrl', text: 'Пример' },
      { value: 'spotIsOff', text: 'Доступно', align: 'center' }
    ],
    items: []
  }),
  mounted () {
    this.load()
  },
  methods: {
    dump () {
//      console.dir(this.selectedItems);
    },
    load () {
      this.selectedItems = []
      this.loading = true;
      api.get('spots/list').then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return alert(response.data.data); //fixme
        this.items = combinedObject(response.data.data.cols, response.data.data.rows);
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    colorByType (type) {
      const colors = { banner: 'orange', shop: 'green', mailing: '#af00af', landing: 'cyan', social: 'blue' };
      return colors.hasOwnProperty(type) ? colors[type] : 'black';
    },
    colorByOff (isOff) {
      return isOff ? 'red' : 'green'
    },
    refreshAction() {
      this.load();
    },
    createAction() {
      this.$refs.spotsDialog.create()
    },
    editAction(item) {
      this.$refs.spotsDialog.edit(item)
    },
    toggleAction(item) {
      api.post('spots/update/'+item.spotID, {spotIsOff: !item.spotIsOff}).then(response => {
        if ( response.data.result !== 'ok' ) return;
        for (let i in this.items)
          if ( this.items[i].spotID == response.data.data.spot.spotID )
          {
            this.items[i].spotIsOff = response.data.data.spot.spotIsOff;
            break;
          }
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    deleteAction (items) {
      if ( !items.length || !confirm('Удалить отмеченные инструменты?') ) return;
      let del = items.reduce((acc, cur, idx) => (acc[idx] = cur.spotID, acc), [])
      this.loading = true
      api.post('spots/delete', {delete: del}).then(response => {
        this.loading = false
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.$root.$alert('Удалено инструментов: '+response.data.data.affected);
        this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style scoped>
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; }
</style>
